import { CHANNEL_ID_MAP } from '~/entity/channel';

export function useCvButtonNavigation() {
  const cvButtonTo = computed(() => {
    return {
      path: '/register',
      query: {
        redirect: '/chat/diagnosis',
        inflow_channel: CHANNEL_ID_MAP.RAKUTEN,
      },
    };
  });

  return {
    cvButtonTo,
  };
}
